import React from "react";
import './UI.css';

const Heading = () => {
    return (
        <div className='heading'>
            <h2>Expense Tracker</h2>
        </div>
    );
};

export default Heading;